import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PatchedRegistrationWriteRequest } from '~/apis/ssf';
import { keys } from './queries';
import { keys as competitionKeys } from '~/pages/competition/queries';
import { keys as competitionTeamKeys } from '~/pages/competition/teams/queries';
import { SSF } from '~/apis/api';

export function useCreateCompetitionRegistrationMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.registrationsCreate>[0]) =>
      SSF.api.registrationsCreate(variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.all });
      client.invalidateQueries({ queryKey: competitionKeys.all });
      client.invalidateQueries({ queryKey: competitionTeamKeys.lists() });
    },
  });
}

export function useDeleteCompetitionRegistrationMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.registrationsDestroy>[0]) =>
      SSF.api.registrationsDestroy(variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.all });
      client.invalidateQueries({ queryKey: competitionKeys.all });
      client.invalidateQueries({ queryKey: competitionTeamKeys.lists() });
    },
  });
}

export function usePartialUpdateCompetitionRegistrationMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: PatchedRegistrationWriteRequest }) =>
      SSF.api.registrationsPartialUpdate(id, payload),
    onSuccess: ({ data: response }) => {
      client.invalidateQueries({ queryKey: keys.detail(response.id) });
      client.invalidateQueries({ queryKey: keys.lists() });
    },
  });
}
